var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-xl": "", fluid: "" } },
                    [
                      _c("h1", { staticClass: "display-1" }, [
                        _vm._v(
                          "TWC API " +
                            _vm._s(_vm.order.purchaseOrderNumber) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              border: "1px solid",
                              padding: "0 10px",
                              "font-size": "16px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.orderFlag))]
                        ),
                        _vm._v(" "),
                        _vm.onlyMotorAccessories
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "right",
                                  border: "1px solid #ea4d76",
                                  color: "#ea4d76",
                                  padding: "0 10px",
                                  "margin-right": "10px",
                                  "font-size": "16px"
                                }
                              },
                              [
                                _vm._v(
                                  "Motor Accessories ONLY - Check with Automation Team"
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.locationNamesOptions,
                          label: "Location"
                        },
                        model: {
                          value: _vm.order.locationName,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "locationName", $$v)
                          },
                          expression: "order.locationName"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.order.contactName,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "contactName", $$v)
                          },
                          expression: "order.contactName"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Email" },
                        model: {
                          value: _vm.order.email,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "email", $$v)
                          },
                          expression: "order.email"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Phone" },
                        model: {
                          value: _vm.order.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "phone", $$v)
                          },
                          expression: "order.phone"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Addres" },
                        model: {
                          value: _vm.order.address1,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "address1", $$v)
                          },
                          expression: "order.address1"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "City" },
                        model: {
                          value: _vm.order.city,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "city", $$v)
                          },
                          expression: "order.city"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "State",
                          items: [
                            { text: "VIC" },
                            { text: "NSW" },
                            { text: "QLD" },
                            { text: "ACT" },
                            { text: "SA" },
                            { text: "NT" },
                            { text: "WA" },
                            { text: "TAS" }
                          ]
                        },
                        model: {
                          value: _vm.order.state,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "state", $$v)
                          },
                          expression: "order.state"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Postcode" },
                        model: {
                          value: _vm.order.postcode,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "postcode", $$v)
                          },
                          expression: "order.postcode"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        attrs: { label: "Delivery Instructions" },
                        model: {
                          value: _vm.order.deliveryInstructions,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "deliveryInstructions", $$v)
                          },
                          expression: "order.deliveryInstructions"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        attrs: { label: "Order Instructions" },
                        model: {
                          value: _vm.order.orderInstructions,
                          callback: function($$v) {
                            _vm.$set(_vm.order, "orderInstructions", $$v)
                          },
                          expression: "order.orderInstructions"
                        }
                      }),
                      _vm._v(" "),
                      _vm.order.remarks
                        ? _c("p", { staticStyle: { color: "red" } }, [
                            _c("b", [_vm._v("Remarks:")]),
                            _vm._v(" " + _vm._s(_vm.order.remarks))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.miscItems.length
                        ? _c("div", { staticClass: "borderPink" }, [
                            _c(
                              "div",
                              {
                                staticClass: "miscItems",
                                on: {
                                  click: function($event) {
                                    _vm.showMiscItems = !_vm.showMiscItems
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Misc Items (" +
                                    _vm._s(_vm.miscItems.length) +
                                    ")"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showMiscItems
                              ? _c(
                                  "div",
                                  _vm._l(_vm.miscItems, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "item" },
                                      [
                                        _c("v-card-title", [
                                          _c(
                                            "h4",
                                            [
                                              _c("v-label", [
                                                _vm._v(_vm._s(item.name))
                                              ])
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        item.notes
                                          ? _c("v-card-text", [
                                              _c("b", [_vm._v("Notes: ")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(item.notes))
                                              ])
                                            ])
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-0",
                          on: {
                            click: function($event) {
                              return _vm.markAll(true)
                            }
                          }
                        },
                        [_vm._v("Mark All")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.markAll(false)
                            }
                          }
                        },
                        [_vm._v("Unmark All")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.order.items, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "item" },
                          [
                            _c(
                              "v-card",
                              { attrs: { flat: !_vm.enabledItems[index] } },
                              [
                                _c("v-card-title", [
                                  _c(
                                    "h4",
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            item.type === "Motor Accessories"
                                              ? item.quantity +
                                                " x " +
                                                item.name +
                                                ": " +
                                                item.type
                                              : item.name + ": " + item.type,
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.enabledItems[index],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.enabledItems,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "enabledItems[index]"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                item.easyLink && _vm.enabledItems[index]
                                  ? _c("v-card-text", [
                                      _c(
                                        "p",
                                        [
                                          _c("b", [_vm._v("Layout: ")]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(item.easyLink))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                fab: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editEasylink(
                                                    index,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("edit")])],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getEasyLinkWidthHtml(
                                              item.easyLink,
                                              item.easyLinkIndividuals
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-divider"),
                                _vm._v(" "),
                                item.type != "Motor Accessories" &&
                                _vm.enabledItems[index]
                                  ? _c(
                                      "v-card-text",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            xs12: "",
                                            md6: "",
                                            label: "Width"
                                          },
                                          model: {
                                            value: item.width,
                                            callback: function($$v) {
                                              _vm.$set(item, "width", $$v)
                                            },
                                            expression: "item.width"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: {
                                            xs12: "",
                                            md6: "",
                                            label: "Drop"
                                          },
                                          model: {
                                            value: item.drop,
                                            callback: function($$v) {
                                              _vm.$set(item, "drop", $$v)
                                            },
                                            expression: "item.drop"
                                          }
                                        }),
                                        _vm._v(" "),
                                        item.type !== "Custom Curtain" &&
                                        item.type !== "Pelmets" &&
                                        item.type !== "Soft Roman Blind"
                                          ? _c("p", [
                                              _c("b", [_vm._v("Fabric")]),
                                              _vm._v(
                                                ": " + _vm._s(item.fabric.name)
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type != "Double Roller Blind" &&
                                        item.type != "Custom Curtain" &&
                                        item.type !== "Soft Roman Blind"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Fabric",
                                                items: _vm.fabrics[item.type],
                                                "item-text": "name",
                                                "item-value": "_id"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.populateFabric(
                                                    item,
                                                    index,
                                                    item.type
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.fabric,
                                                callback: function($$v) {
                                                  _vm.$set(item, "fabric", $$v)
                                                },
                                                expression: "item.fabric"
                                              }
                                            })
                                          : item.type != "Custom Curtain" &&
                                            item.type !== "Soft Roman Blind"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Fabric",
                                                items:
                                                  _vm.fabrics["Roller Blind"],
                                                "item-text": "name",
                                                "item-value": "_id"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.populateFabric(
                                                    item,
                                                    index,
                                                    "Roller Blind"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.fabric,
                                                callback: function($$v) {
                                                  _vm.$set(item, "fabric", $$v)
                                                },
                                                expression: "item.fabric"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type != "Custom Curtain" &&
                                        item.type !== "Pelmets" &&
                                        item.type !== "Soft Roman Blind"
                                          ? _c("p", [
                                              _c("b", [_vm._v("Colour")]),
                                              _vm._v(
                                                ": " + _vm._s(item.color.name)
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type != "Custom Curtain" &&
                                        item.type !== "Soft Roman Blind"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Colour",
                                                items: _vm.colors,
                                                "item-text": "name",
                                                "item-value": "_id"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.populateColor(
                                                    item,
                                                    index
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.color,
                                                callback: function($$v) {
                                                  _vm.$set(item, "color", $$v)
                                                },
                                                expression: "item.color"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(item.variations, function(
                                          variation,
                                          vIndex
                                        ) {
                                          return _c("div", { key: vIndex }, [
                                            variation &&
                                            vIndex !== "fabricPricePerMeter" &&
                                            vIndex !== "fabricRollWidth" &&
                                            vIndex !== "fabricColorLabel" &&
                                            vIndex !== "fullness" &&
                                            vIndex !== "margin" &&
                                            vIndex !== "midrailHeight" &&
                                            vIndex !== "tPostDimension" &&
                                            vIndex !== "tPostMeasurement1" &&
                                            vIndex !== "tPostMeasurement2" &&
                                            vIndex !== "tPosts" &&
                                            vIndex !== "tPostCount"
                                              ? _c(
                                                  "p",
                                                  [
                                                    vIndex == "multiplier"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "Stack Option: "
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              vIndex
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                                vIndex
                                                                  .slice(1)
                                                                  .split(
                                                                    /(?=[A-Z])/
                                                                  )
                                                                  .join(" ")
                                                            ) + ": "
                                                          )
                                                        ]),
                                                    _vm._v(" "),
                                                    vIndex == "secondFabric"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                variation.name
                                                              ) +
                                                                "\n                      "
                                                            ),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Second Fabric",
                                                                items:
                                                                  _vm.fabrics[
                                                                    "Roller Blind"
                                                                  ],
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "_id"
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.populateSecondFabric(
                                                                    item,
                                                                    index,
                                                                    "Roller Blind"
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondFabric,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondFabric",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondFabric"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : vIndex == "secondColor"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                variation.name
                                                              ) +
                                                                "\n                      "
                                                            ),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label: "Colour",
                                                                items:
                                                                  _vm.secondColors,
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "_id"
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.populateSecondColor(
                                                                    item,
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondColor,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondColor",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondColor"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : vIndex == "brand"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                variation.name
                                                              ) +
                                                                "\n                      "
                                                            ),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label: "Brand",
                                                                items:
                                                                  _vm.brands,
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "_id"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.populateBrand(
                                                                    item,
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .brand,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "brand",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.brand"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : vIndex == "range"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                variation.name
                                                              ) +
                                                                "\n                      "
                                                            ),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label: "Range",
                                                                items:
                                                                  _vm.ranges,
                                                                "item-text":
                                                                  "name",
                                                                "item-value":
                                                                  "_id"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.populateRanges(
                                                                    item,
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .range,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "range",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.range"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : vIndex ==
                                                          "multiplier" &&
                                                        variation == 1
                                                      ? _c("span", [
                                                          _vm._v(" One Way ")
                                                        ])
                                                      : vIndex ==
                                                          "multiplier" &&
                                                        variation == 2
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " Center Open "
                                                          )
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(variation)
                                                          )
                                                        ]),
                                                    _vm._v(" "),
                                                    ![
                                                      "brand",
                                                      "range",
                                                      "panelCombination",
                                                      "railMeasurement",
                                                      "panelMeasurements",
                                                      "widthLeft",
                                                      "widthMiddle",
                                                      "widthRight"
                                                    ].includes(vIndex)
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              flat: "",
                                                              fab: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.editVariation(
                                                                  index,
                                                                  vIndex,
                                                                  item
                                                                    .variations[
                                                                    vIndex
                                                                  ]
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v("edit")
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ])
                                        }),
                                        _vm._v(" "),
                                        item.type == "Double Roller Blind"
                                          ? _c(
                                              "v-expansion-panel",
                                              [
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "header" },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            "Second Roller Blind Options"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Fitting",
                                                                items: [
                                                                  {
                                                                    text: "Face"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Recess"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondFitting,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondFitting",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondFitting"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Control Side",
                                                                items: [
                                                                  {
                                                                    text: "Left"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Right"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondControlSide,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondControlSide",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondControlSide"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Roll Direction",
                                                                items: [
                                                                  {
                                                                    text:
                                                                      "Front"
                                                                  },
                                                                  {
                                                                    text: "Back"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondRollDirection,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondRollDirection",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondRollDirection"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Chain Color",
                                                                items: [
                                                                  {
                                                                    text:
                                                                      "Silver Metal"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Black"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "White"
                                                                  },
                                                                  {
                                                                    text: "Grey"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondChainColor,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondChainColor",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondChainColor"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Bracket Color",
                                                                items: [
                                                                  {
                                                                    text:
                                                                      "Black"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "White"
                                                                  },
                                                                  {
                                                                    text: "Grey"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Ivory"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondBracketColor,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondBracketColor",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondBracketColor"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Base Rail Shape",
                                                                items: [
                                                                  {
                                                                    text: "Oval"
                                                                  },
                                                                  {
                                                                    text: "D30"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Heavy Duty"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Small Flat"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondBaseRailShape,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondBaseRailShape",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondBaseRailShape"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Base Rail Colour",
                                                                items: [
                                                                  {
                                                                    text:
                                                                      "Anodised Silver"
                                                                  },
                                                                  {
                                                                    text: "Dune"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Bronze Pearl"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Satin Black"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "White"
                                                                  },
                                                                  {
                                                                    text: "Bone"
                                                                  },
                                                                  {
                                                                    text:
                                                                      "Sandstone"
                                                                  }
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .secondBaseRailColor,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "secondBaseRailColor",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.secondBaseRailColor"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Shutter"
                                          ? _c(
                                              "v-expansion-panel",
                                              [
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "header" },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            "Shutter Options"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            item.variations
                                                              .rail ==
                                                              "Single Rail" ||
                                                            item.variations
                                                              .rail ==
                                                              "Double Rail"
                                                              ? _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Midrail Height"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .midrailHeight,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item.variations,
                                                                          "midrailHeight",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.midrailHeight"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Panel Combination",
                                                                items:
                                                                  _vm
                                                                    .availableOptions
                                                                    .panelCombination
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateTPostCount(
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .panelCombination,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "panelCombination",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.panelCombination"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              item.variations
                                                                .tPostCount,
                                                              function(n) {
                                                                return _c(
                                                                  "v-text-field",
                                                                  {
                                                                    key: n,
                                                                    attrs: {
                                                                      label:
                                                                        "T-Post #" +
                                                                        n
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .tPosts[
                                                                          n - 1
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item
                                                                            .variations
                                                                            .tPosts,
                                                                          n - 1,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.tPosts[n - 1]"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "3D Shutters"
                                          ? _c(
                                              "v-expansion-panel",
                                              [
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "header" },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            "Shutter Options"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            item.variations
                                                              .rail ==
                                                              "Single Rail" ||
                                                            item.variations
                                                              .rail ==
                                                              "Double Rail"
                                                              ? _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Midrail Height"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .midrailHeight,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item.variations,
                                                                          "midrailHeight",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.midrailHeight"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Panel Combination Left",
                                                                items:
                                                                  _vm
                                                                    .availableOptions
                                                                    .panelCombinationLeft
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateTPostCountLeft(
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .panelCombinationLeft,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "panelCombinationLeft",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.panelCombinationLeft"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              item.variations
                                                                .tPostCountLeft,
                                                              function(n) {
                                                                return _c(
                                                                  "v-text-field",
                                                                  {
                                                                    key: n,
                                                                    attrs: {
                                                                      label:
                                                                        "T-Post Left#" +
                                                                        n
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .tPostsLeft[
                                                                          n - 1
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item
                                                                            .variations
                                                                            .tPostsLeft,
                                                                          n - 1,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.tPostsLeft[n - 1]"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            item.variations
                                                              .layout !==
                                                            "Corner"
                                                              ? _c("v-select", {
                                                                  attrs: {
                                                                    label:
                                                                      "Panel Combination Middle",
                                                                    items:
                                                                      _vm
                                                                        .availableOptions
                                                                        .panelCombinationMiddle
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateTPostCountMiddle(
                                                                        index
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item
                                                                        .variations
                                                                        .panelCombinationMiddle,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item.variations,
                                                                        "panelCombinationMiddle",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "item.variations.panelCombinationMiddle"
                                                                  }
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              item.variations
                                                                .tPostCountMiddle,
                                                              function(n) {
                                                                return _c(
                                                                  "v-text-field",
                                                                  {
                                                                    key: n,
                                                                    attrs: {
                                                                      label:
                                                                        "T-Post Middle#" +
                                                                        n
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .tPostsMiddle[
                                                                          n - 1
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item
                                                                            .variations
                                                                            .tPostsMiddle,
                                                                          n - 1,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.tPostsMiddle[n - 1]"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c("v-select", {
                                                              attrs: {
                                                                label:
                                                                  "Panel Combination Right",
                                                                items:
                                                                  _vm
                                                                    .availableOptions
                                                                    .panelCombinationRight
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateTPostCountRight(
                                                                    index
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  item
                                                                    .variations
                                                                    .panelCombinationRight,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    item.variations,
                                                                    "panelCombinationRight",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "item.variations.panelCombinationRight"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              item.variations
                                                                .tPostCountRight,
                                                              function(n) {
                                                                return _c(
                                                                  "v-text-field",
                                                                  {
                                                                    key: n,
                                                                    attrs: {
                                                                      label:
                                                                        "T-Post Right#" +
                                                                        n
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item
                                                                          .variations
                                                                          .tPostsRight[
                                                                          n - 1
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item
                                                                            .variations
                                                                            .tPostsRight,
                                                                          n - 1,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.variations.tPostsRight[n - 1]"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Roller Blind"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Bracket Type",
                                                items:
                                                  _vm.availableOptions
                                                    .bracketType
                                              },
                                              model: {
                                                value:
                                                  item.variations.bracketType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "bracketType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.bracketType"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Opening",
                                                items:
                                                  _vm.availableOptions.opening
                                              },
                                              model: {
                                                value: item.variations.opening,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "opening",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.opening"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Heading Type",
                                                items:
                                                  _vm.availableOptions.heading
                                              },
                                              model: {
                                                value: item.variations.heading,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "heading",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.heading"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain" ||
                                        item.type == "Custom Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Bottom Finish",
                                                items:
                                                  _vm.availableOptions
                                                    .bottomFinish
                                              },
                                              model: {
                                                value:
                                                  item.variations.bottomFinish,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "bottomFinish",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.bottomFinish"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Track",
                                                items: _vm.getTrackList(
                                                  item.variations.heading
                                                )
                                              },
                                              model: {
                                                value: item.variations.track,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "track",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.track"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Motor",
                                                items:
                                                  _vm.availableOptions.motorList
                                              },
                                              model: {
                                                value: item.variations.motor,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "motor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.motor"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Motor Side",
                                                items: ["Left", "Right"]
                                              },
                                              model: {
                                                value:
                                                  item.variations.motorSide,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "motorSide",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.motorSide"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-select", {
                                              attrs: {
                                                label: "Free Flow",
                                                items:
                                                  _vm.availableOptions.freeFlow
                                              },
                                              model: {
                                                value: item.variations.freeFlow,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "freeFlow",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.freeFlow"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain"
                                          ? _c("v-checkbox", {
                                              attrs: {
                                                type: "checkbox",
                                                label: "Split Track",
                                                color: "primary"
                                              },
                                              model: {
                                                value:
                                                  item.variations.splitTrack,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.variations,
                                                    "splitTrack",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.variations.splitTrack"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.notes
                                          ? _c(
                                              "p",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _c("b", [_vm._v("Note:")]),
                                                _vm._v(" " + _vm._s(item.notes))
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-checkbox", {
                                          attrs: {
                                            type: "checkbox",
                                            label: "Make Size",
                                            color: "primary"
                                          },
                                          model: {
                                            value: item.makeSize,
                                            callback: function($$v) {
                                              _vm.$set(item, "makeSize", $$v)
                                            },
                                            expression: "item.makeSize"
                                          }
                                        }),
                                        _vm._v(" "),
                                        item.type === "Double Curtain"
                                          ? _c("strong", [
                                              _vm._v("Sending Option")
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type === "Double Curtain"
                                          ? _c(
                                              "v-radio-group",
                                              {
                                                attrs: { row: "" },
                                                model: {
                                                  value: item.sendOption,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "sendOption",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.sendOption"
                                                }
                                              },
                                              [
                                                _c("v-radio", {
                                                  attrs: {
                                                    label: "Both",
                                                    color: "primary",
                                                    value: "both"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-radio", {
                                                  attrs: {
                                                    label: "Only Sheer",
                                                    color: "primary",
                                                    value: "sheer"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-radio", {
                                                  attrs: {
                                                    label: "Only Blockout",
                                                    color: "primary",
                                                    value: "blockout"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Double Curtain"
                                          ? _c("v-checkbox", {
                                              attrs: {
                                                type: "checkbox",
                                                label: "send only Curtain",
                                                color: "primary"
                                              },
                                              on: {
                                                change: function($event) {
                                                  item.curtainTrackonly = false
                                                }
                                              },
                                              model: {
                                                value: item.curtainonly,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "curtainonly",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.curtainonly"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Curtain" ||
                                        item.type == "Custom Curtain" ||
                                        item.type == "Double Curtain" ||
                                        item.type == "Lined Curtain"
                                          ? _c("v-checkbox", {
                                              attrs: {
                                                type: "checkbox",
                                                label:
                                                  "send only Curtain Tracks",
                                                color: "primary"
                                              },
                                              on: {
                                                change: function($event) {
                                                  item.curtainonly = false
                                                }
                                              },
                                              model: {
                                                value: item.curtainTrackonly,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "curtainTrackonly",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.curtainTrackonly"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Custom Curtain"
                                          ? _c("v-textarea", {
                                              attrs: { label: "Add Note" },
                                              model: {
                                                value: item.documentNote,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "documentNote",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.documentNote"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br")
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: {
                          label: "Express",
                          color: "primary",
                          type: "checkbox"
                        },
                        model: {
                          value: _vm.express,
                          callback: function($$v) {
                            _vm.express = $$v
                          },
                          expression: "express"
                        }
                      }),
                      _vm._v(" "),
                      _vm.order.deliveryMethod
                        ? _c("p", { staticStyle: { color: "red" } }, [
                            _c("b", [_vm._v("Delivery Method:")]),
                            _vm._v(" " + _vm._s(_vm.order.deliveryMethod))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.sending,
                            disabled: _vm.sending
                          },
                          on: {
                            click: function($event) {
                              return _vm.submitToTWC(false)
                            }
                          }
                        },
                        [_vm._v("Submit")]
                      ),
                      _vm._v(" "),
                      _vm.anyDisabled
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                flat: "",
                                loading: _vm.sending,
                                disabled: _vm.sending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitToTWCDownload(false)
                                }
                              }
                            },
                            [_vm._v("Submit & Download")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            flat: "",
                            loading: _vm.sending,
                            disabled: _vm.sending
                          },
                          on: {
                            click: function($event) {
                              return _vm.checkTwcOrderStatus(true)
                            }
                          }
                        },
                        [_vm._v("Submit Test")]
                      ),
                      _vm._v(" "),
                      _vm.anyDisabled
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "error",
                                flat: "",
                                loading: _vm.sending,
                                disabled: _vm.sending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitToTWCDownload(true)
                                }
                              }
                            },
                            [_vm._v("Submit Test & Download")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.anyCurtains
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                small: "",
                                loading: _vm.sending,
                                disabled: _vm.sending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadCurtainDoc()
                                }
                              }
                            },
                            [_vm._v("Download Curtain Doc")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.softRomanBlind
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                small: "",
                                loading: _vm.sending,
                                disabled: _vm.sending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadSoftRomanBlindDoc()
                                }
                              }
                            },
                            [_vm._v("Download Soft Roman Blind Doc")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: { persistent: "", width: "300" },
                          model: {
                            value: _vm.sending,
                            callback: function($$v) {
                              _vm.sending = $$v
                            },
                            expression: "sending"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "primary", dark: "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _vm._v(
                                    "\n                Sending to Factory...\n                "
                                  ),
                                  _c("v-progress-linear", {
                                    staticClass: "mb-0",
                                    attrs: { indeterminate: "", color: "white" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: { persistent: "", width: "300" },
                          model: {
                            value: _vm.twcOrderCheck,
                            callback: function($$v) {
                              _vm.twcOrderCheck = $$v
                            },
                            expression: "twcOrderCheck"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-text", [
                                _c("h3", [
                                  _vm._v(
                                    "This order number has already sent to TWC - do you want to continue?"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mt-4" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.submitToTWC(_vm.testing),
                                              (_vm.twcOrderCheck = false)
                                          }
                                        }
                                      },
                                      [_vm._v(" Yes ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.twcOrderCheck = false
                                          }
                                        }
                                      },
                                      [_vm._v(" No ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: { scrollable: "", "max-width": "600px" },
                          model: {
                            value: _vm.outputDialog,
                            callback: function($$v) {
                              _vm.outputDialog = $$v
                            },
                            expression: "outputDialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [_vm._v("TWC Response")]),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-tabs",
                                {
                                  staticStyle: {
                                    height: "300px",
                                    overflow: "hidden"
                                  },
                                  attrs: {
                                    color: "primary",
                                    dark: "",
                                    "slider-color": "secondary"
                                  },
                                  model: {
                                    value: _vm.outputDialogTabs,
                                    callback: function($$v) {
                                      _vm.outputDialogTabs = $$v
                                    },
                                    expression: "outputDialogTabs"
                                  }
                                },
                                [
                                  _c(
                                    "v-tab",
                                    { key: 1, attrs: { ripple: "" } },
                                    [_vm._v("Summary")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab",
                                    { key: 2, attrs: { ripple: "" } },
                                    [_vm._v("Input")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    { key: 1 },
                                    [
                                      _c(
                                        "v-card-text",
                                        _vm._l(_vm.twcResponses, function(
                                          response,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              response
                                                ? [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(response.type) +
                                                          ":"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    response.success == true
                                                      ? _c("span", [
                                                          _vm._v("Success")
                                                        ])
                                                      : _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              "Failed<br>" +
                                                                response.message
                                                            )
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("v-divider")
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    { key: 2 },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          rows: "15",
                                          height: "100%",
                                          readonly: "",
                                          value: _vm.twcInput
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", flat: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.outputDialog = false
                                        }
                                      }
                                    },
                                    [_vm._v("Close")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedVariation
                        ? _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "600px" },
                              model: {
                                value: _vm.variationDialog,
                                callback: function($$v) {
                                  _vm.variationDialog = $$v
                                },
                                expression: "variationDialog"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedVariation.variationKey
                                            .charAt(0)
                                            .toUpperCase() +
                                            _vm.selectedVariation.variationKey
                                              .slice(1)
                                              .split(/(?=[A-Z])/)
                                              .join(" ")
                                        ) + ": "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Value",
                                          items:
                                            _vm.availableOptions[
                                              _vm.selectedVariation.variationKey
                                            ]
                                        },
                                        model: {
                                          value:
                                            _vm.order.items[
                                              _vm.selectedVariation.itemIndex
                                            ].variations[
                                              _vm.selectedVariation.variationKey
                                            ],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.order.items[
                                                _vm.selectedVariation.itemIndex
                                              ].variations,
                                              _vm.selectedVariation
                                                .variationKey,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "order.items[selectedVariation.itemIndex].variations[selectedVariation.variationKey]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.variationDialog = false
                                            }
                                          }
                                        },
                                        [_vm._v("Close")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItemIndex !== null
                        ? _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "600px" },
                              model: {
                                value: _vm.EasylinkDialog,
                                callback: function($$v) {
                                  _vm.EasylinkDialog = $$v
                                },
                                expression: "EasylinkDialog"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("h4", [_vm._v("Easylink")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Easylink",
                                          items: [
                                            "LL",
                                            "LR",
                                            "RR",
                                            "LLL",
                                            "LLR",
                                            "LRR",
                                            "RRR"
                                          ]
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.resetEasyLinkIndividuals()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.order.items[
                                              _vm.selectedItemIndex
                                            ].easyLink,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.order.items[
                                                _vm.selectedItemIndex
                                              ],
                                              "easyLink",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "order.items[selectedItemIndex].easyLink"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.order.items[_vm.selectedItemIndex]
                                        .easyLink === "LR"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "LL"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "RR"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "LLL"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Middle Width"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "RRR"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Middle Width"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "LLR"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Middle Width"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm.order.items[_vm.selectedItemIndex]
                                            .easyLink === "LRR"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-text-field", {
                                                attrs: { label: "Left Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.l1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "l1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.l1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Middle Width"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: { label: "Right Width" },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.recalculateTotalWidth()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.order.items[
                                                      _vm.selectedItemIndex
                                                    ].easyLinkIndividuals.r3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.order.items[
                                                        _vm.selectedItemIndex
                                                      ].easyLinkIndividuals,
                                                      "r3",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "order.items[selectedItemIndex].easyLinkIndividuals.r3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.EasylinkDialog = false
                                            }
                                          }
                                        },
                                        [_vm._v("Close")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75d34daa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d34daa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/TWCAPI.vue
// module id = null
// module chunks = 